<template>
  <v-alert v-if="template && template.instructions"
           type="info">
    {{ template.instructions }}
  </v-alert>
</template>
<script>
export default {
  props: {
    template: {
      type: Object,
    }
  }
}
</script>
